import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{this.title}}
  @closeModal={{@closeModal}}
  class="group-add-members-modal"
  @flash={{this.flash}}
>
  <:body>
    <form class="form-vertical group-add-members">
      <p>{{i18n "groups.add_members.description"}}</p>
      <div class="input-group">
        <EmailGroupUserChooser
          @value={{this.usernamesAndEmails}}
          @onChange={{this.setUsernamesAndEmails}}
          @options={{hash
            allowEmails=this.currentUser.can_invite_to_forum
            filterPlaceholder=(if
              this.currentUser.can_invite_to_forum
              "groups.add_members.usernames_or_emails_placeholder"
              "groups.add_members.usernames_placeholder"
            )
          }}
        />
      </div>

      {{#if @model.can_admin_group}}
        <div class="input-group">
          <label>
            <Input
              id="set-owner"
              @type="checkbox"
              @checked={{this.setOwner}}
              disabled={{this.emails}}
            />
            {{i18n "groups.add_members.set_owner"}}
          </label>
        </div>
      {{/if}}

      <div class="input-group">
        <label>
          <Input
            @type="checkbox"
            @checked={{this.notifyUsers}}
            disabled={{and (not this.usernames) this.emails}}
          />
          {{i18n "groups.add_members.notify_users"}}
        </label>
      </div>
    </form>
  </:body>
  <:footer>
    <DButton
      @action={{this.addMembers}}
      class="add btn-primary"
      @icon="plus"
      @disabled={{or this.loading (not this.usernamesAndEmails)}}
      @label="groups.add"
    />
  </:footer>
</DModal>
*/
{
  "id": "SeI+koFz",
  "block": "[[[8,[39,0],[[24,0,\"group-add-members-modal\"]],[[\"@title\",\"@closeModal\",\"@flash\"],[[30,0,[\"title\"]],[30,1],[30,0,[\"flash\"]]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,\"form\"],[14,0,\"form-vertical group-add-members\"],[12],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"groups.add_members.description\"],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"input-group\"],[12],[1,\"\\n        \"],[8,[39,2],null,[[\"@value\",\"@onChange\",\"@options\"],[[30,0,[\"usernamesAndEmails\"]],[30,0,[\"setUsernamesAndEmails\"]],[28,[37,3],null,[[\"allowEmails\",\"filterPlaceholder\"],[[30,0,[\"currentUser\",\"can_invite_to_forum\"]],[52,[30,0,[\"currentUser\",\"can_invite_to_forum\"]],\"groups.add_members.usernames_or_emails_placeholder\",\"groups.add_members.usernames_placeholder\"]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,2,[\"can_admin_group\"]],[[[1,\"        \"],[10,0],[14,0,\"input-group\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,\"\\n            \"],[8,[39,5],[[24,1,\"set-owner\"],[16,\"disabled\",[30,0,[\"emails\"]]]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"setOwner\"]]]],null],[1,\"\\n            \"],[1,[28,[35,1],[\"groups.add_members.set_owner\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"input-group\"],[12],[1,\"\\n        \"],[10,\"label\"],[12],[1,\"\\n          \"],[8,[39,5],[[16,\"disabled\",[28,[37,6],[[28,[37,7],[[30,0,[\"usernames\"]]],null],[30,0,[\"emails\"]]],null]]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"notifyUsers\"]]]],null],[1,\"\\n          \"],[1,[28,[35,1],[\"groups.add_members.notify_users\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,8],[[24,0,\"add btn-primary\"]],[[\"@action\",\"@icon\",\"@disabled\",\"@label\"],[[30,0,[\"addMembers\"]],\"plus\",[28,[37,9],[[30,0,[\"loading\"]],[28,[37,7],[[30,0,[\"usernamesAndEmails\"]]],null]],null],\"groups.add\"]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"i18n\",\"email-group-user-chooser\",\"hash\",\"if\",\"input\",\"and\",\"not\",\"d-button\",\"or\"]]",
  "moduleName": "discourse/components/modal/group-add-members.hbs",
  "isStrictMode": false
});